import { SecuredPaymentClient } from '../../../Core/Api/Payment/SecuredPaymentClient';
import {
  ConfirmCreditCardRegistrationRequestBody,
  AddressDto,
  ReferenceValueDto,
  IReferenceValueDto,
  ExecuteBillOfLadingPaymentRequest,
  BillOfLadingPaymentResponse,
  BeginBillPaymentResponse,
  BeginBillPaymentRequest,
} from '../../../Core/Api/Payment/Api';
import ConfigUtility from 'Core/ConfigUtility';
import TokenUtility from 'Core/TokenUtility';

export class CheckoutHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  makePayment(request: BeginBillPaymentRequest) {
    const client = new SecuredPaymentClient();
    const config = ConfigUtility.getSync()!;
    request.cashierId = config.CashierId;
    client.DisableToken = true;
    client.showLoading = false;
    // request.paymentMethod['_discriminator'] = 'CreditCardPaymentMethodDto';
    // request.paymentMethod['$type'] = 'CreditCardPaymentMethodDto';

    // need to stop JSON.stringify from change type property
    const authorization = TokenUtility.GetUMAToken();

    return client.beginBillPayment('Bearer ' + authorization, request);
  }
}
